export const FEATURE_PRODUCT_CREATE = "PRODUCT_CREATE"
export const FEATURE_EXTERNAL_LOCATION_PICKER = "EXTERNAL_LOCATION_PICKER"
export const FEATURE_MAX_SALES_QUANTITY = "MAX_SALES_QUANTITY"

export const AUTH_FLOW_OAUTH = "oauth"

export type SettingSpec = {
  key: string
  label: string
  helpText?: string | null
  secret: boolean
  required: boolean
  inputType?: string | null
  options?: { value: string; label: string }[] | null
  defaultValue?: string | null
  visibleWhenKey?: string | null
  visibleWhenValue?: string | null
}

/** The value a setting has on screen: what was entered, else the connector's default. */
export const settingValue = (spec: SettingSpec, values: Record<string, string>): string =>
  values[spec.key] ?? spec.defaultValue ?? ""

/** A setting the connector shows only while another setting has a given value. */
export const isSettingShown = (spec: SettingSpec, specs: SettingSpec[], values: Record<string, string>): boolean => {
  if (!spec.visibleWhenKey) return true
  const controller = specs.find((s) => s.key === spec.visibleWhenKey)
  return !!controller && settingValue(controller, values) === spec.visibleWhenValue
}

/** Query param the OAuth callback uses to report a failed authorisation. */
export const AUTH_ERROR_PARAM = "auth_error"
